import { SOFTWARE_PART_TYPE } from 'app/[lang]/[esite]/(core)/product/[product]/constants/constants';

export const SOFTWARE_PART_TYPE_LOWER = SOFTWARE_PART_TYPE.toLowerCase();
export const TAX_EXCLUDED_PCC_TAX_DISCLAIMER = '51';
export const TAX_INCLUDED_PCC_TAX_DISCLAIMER = '54';
